// conductor-emit-hash: c342c86c
// generated by pbo-conductor — 입고조회(전체) (gr05)
// conductor-build: 26fd10a5 2026-09-18T12:12:38.235Z · pbo-core 0.8.2
// dev 위치: pages/inbound/inboundInquiryAll
// 데이터 seam: useGetInboundInquiryAllList — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//   filterCard #e70a16
//     · platform(배치 규약(desktop 라벨 위·3~4열 / moss 라벨 왼쪽·항상 3열)) = desktop | moss [기본 desktop]
//     · searchText(조회 버튼 문구) — 자유 입력
//     · resetText(초기화 버튼 문구) — 자유 입력
//     · defaultCollapsed(진입 시 접힘) = 켬 | 끔 [기본 false]
//     · summaryMessage(요약 카드 아래 안내 문구(summary 슬롯 있을 때)) — 자유 입력
//     · cols(한 줄 항목 수(moss)) 3~3개
//     · colGap(항목 가로 간격(moss)) 제한 없음
//     · rowGap(줄 세로 간격(moss)) 제한 없음
//     · labelWidth(라벨 칸 고정폭(moss)) 제한 없음
//     · labelGap(라벨-값 간격(moss)) 제한 없음
//     · itemMaxWidth(필터 항목 최대 폭) ≤ 420px [기본 420px]
//     · itemsPerRow(한 줄 항목 수) 3~4개 [기본 4개]
//     · collapsedShows(접었을 때 노출) = 값이 있는 항목만 | 전부 [기본 값이 있는 항목만]
//     · twoColBreakpoint(2단 필드 칩 접힘 폭) 제한 없음 [기본 320px]
//     · valueMinWidth(값 컨트롤 최소 폭) 제한 없음 [기본 240px]
//     · typeMinWidth(유형 셀렉트 최소 폭) 제한 없음 [기본 88px]
//     · typeMaxWidth(유형 셀렉트 최대 폭) 제한 없음 [기본 120px]
//     · 필터 항목 width는 max 420px 해상도에 따라 조절
//     · 한 줄에 필터 항목 3개부터 최대 4개까지 노출.
//     · 필터 접기 시, 값이 있는 필터만 노출
//     · 필터 접기 시, 값이 전부 없는 경우 문구 노출.
//   tableGroup #7b6f57
//     · pagerVariant(페이저 표기) = paged | range [기본 paged]
//     · pager(페이저 노출) = 켬 | 끔 [기본 true]
//     · listSearch(목록 검색 노출) = 켬 | 끔 [기본 true]
//     · pagerSizeChanger('몇개씩' 노출) = auto | hide [기본 auto]
//     · rightFirst(화면 우측 요소를 표준 앞에) = 켬 | 끔 [기본 false]
//     · leadColumns(선두 컬럼) = 체크박스 → No | No | 없음 [기본 체크박스 → No]
//     · checkboxWidth(체크박스 폭) 제한 없음 [기본 48px]
//     · noWidth(No 폭) 제한 없음 [기본 48px]
//     · 값·말줄임 짤림 금지 — 컬럼 폭은 콘텐츠 맞춤
//     · 엑셀 다운로드는 exportColumns(한글 헤더) 지정
//
import { core } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import '../screenShell.css'
import { type ComponentProps, type ReactNode, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { CloseCircleFilled, DownOutlined, PlusOutlined, SearchOutlined, UpOutlined } from '@ant-design/icons'
import dayjs, { type Dayjs } from 'dayjs'
import { Icon as DsIcon } from '@musinsa/pbo-assets'
import { usePageHeaderSticky } from '../pageHeaderSticky'
import type { ButtonCode, ToolbarConfig } from '@/services/auth/menu.types'

// 컴포넌트 모드(문서 51) — 이 파일은 겉(UI)만이다. 배선(Wiring)은 화면 엔트리(개발자 소유)가 props 로 넘긴다 — 옛 훅·API·핸들러를 그대로 쓰면 된다.
//  모듈 홀더: 확인창 함수·선택 게이트 등 모듈 수준 코드가 같은 배선을 보도록 렌더 첫머리에서 갱신한다. props.wiring 은 렌더마다 새 객체여도 된다(효과 의존성에 쓰지 않는다).
let wiring: Wiring = { rows: {}, actions: {} } as Wiring
// 버튼 권한 슬롯(LOGISPRD-16733) — 슬롯이 없으면 전부 보이고 편집된다.
const permCan = (code: ButtonCode) => wiring.permission?.canShow(code) ?? true
const permTool = (key: keyof ToolbarConfig) => wiring.permission?.toolbar[key] ?? true
const permCols = (columns: core.CoreColumnType[]) => wiring.permission?.columns(columns) ?? columns

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined. */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number } }
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; form?: FormState } // form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
/** 표 컬럼 배치(2026-10-21) — DS core.Table 의 제어형 prop 그대로. 컬럼 id = dataIndex(재핸드오프로 dataIndex 가 바뀌면 그 컬럼 저장값은 무시된다).
 *  순서·너비는 조절한 것만 와도 된다. 초기화는 []/{} (undefined 로 바꾸면 비제어로 돌아가 직전 내부 상태가 남는다). */
export type ColumnLayout = Pick<core.CoreTableProps, 'columnOrder' | 'onColumnOrderChange' | 'columnWidths' | 'onColumnWidthsChange' | 'pinnedColumns' | 'onPinnedColumnsChange' | 'hiddenColumns' | 'onHiddenColumnsChange'>
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: { ROWS: (demo: Row[], q: RowsQuery) => Row[] | { rows: Row[]; total?: number; loading?: boolean } }
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { search: (filters: Record<string, unknown>) => void | Promise<void>; inqAllDownloadModal_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** [초기화] 때 — 저장된 조회 조건(URL/세션)과 조회 결과도 지운다(옛 손코드 handleFilterReset). 생성본은 조회영역 값·페이저·선택·목록 검색어를 되돌린다. 없으면 화면 값만. */
  onReset?: () => void
  /** 화면 상태(페이저·목록 검색어) 진입 초기값 — 동기 함수 아님, 값(예: URL 복원). 없으면 데모 기본값(1페이지·빈 검색어). */
  stateInitial?: { pager?: { "pager"?: { page?: number; size?: number } }; listq?: { "table.q"?: string } }
  /** 화면 상태가 바뀔 때(페이지 이동·검색어 확정·조회 초기화) — 배선이 URL/세션에 싣는다(옛 손코드 page/keyword persist). */
  onState?: (s: { pager: { "pager": { page: number; size: number } }; listq: { "table.q": string } }) => void
  /** 모달 열기 전 가드 — 버튼 클릭 때 선택 행(ctx.selected)으로 부른다. false 를 돌려주면 열지 않는다(왜 못 여는지는 배선이 토스트로). 없으면 그냥 연다. */
  opens?: { inqAllExcelButton?: (ctx: ActionCtx) => boolean }
  /** 옵션 — 조회영역 셀렉트·라디오·편집 셀 셀렉트의 선택지. 인자는 데모 옵션(자리 표시). 컴포넌트 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅(콤보 API 등)을 써도 된다.
   *  데모는 value=label 목데이터라, API 로 바꾸면(예: 화주 = 코드) 조회 조건·저장 값도 그 value 로 나간다 — 조회 기본값은 filterDefaults 로 같이 맞출 것. */
  options?: { INQALLSHIPPER_TYPE_OPTIONS?: (demo: Option[]) => Option[]; INQALLSHIPPER_NAME_OPTIONS?: (demo: Option[]) => Option[]; INQALLORDTYPE_OPTIONS?: (demo: Option[]) => Option[]; INQALLORDSTATUS_OPTIONS?: (demo: Option[]) => Option[]; REASONRADIO_OPTIONS?: (demo: Option[]) => Option[] }
  /** 조회 조건 기본값 — 데모 기본값(예: 화주명 "무신사스탠다드")을 실값(예: 로그인 사용자 화주 코드)으로 덮어쓴다. **동기 함수**(훅 금지 — useMemo 안에서 한 번 계산). */
  filterDefaults?: { inqAllFilterCard?: (demo: Record<string, unknown>) => Record<string, unknown> }
  /** 진입 초기값 — 기본값 위에 URL/세션 복원값을 얹는다(동기 함수). [초기화] 는 여기 값이 아니라 filterDefaults 로 돌아간다. */
  filterInitial?: { inqAllFilterCard?: (defaults: Record<string, unknown>) => Record<string, unknown> }
  /** 폼 버스 파생 필드 — 데모에서 스코프(화면 배선)가 채우던 값(예: 지난 날짜면 locked=true)을 입력 값(state)에서 계산해 덮어쓴다. 없으면 입력 값 그대로. */
  form?: { inqAllDownloadModal?: (state: FormState) => FormState }
  /** 조회영역 칸 잠금 — 키 = 조회 조건 키(filterKey). true 면 그 칸을 비활성으로 그린다(예: 화주 고정 계정의 화주유형/화주명).
   *  값은 잠그지 않는다 — 잠긴 칸의 값은 filterDefaults 로 넣고, 조회 슬롯에서도 서버로 나가는 값을 직접 고정할 것. */
  filterDisabled?: { service_type?: boolean; shipper_name?: boolean }
  /** 표 컬럼 배치(2026-10-21, LOGISPRD-15649) — 사용자가 바꾼 순서·너비·고정·숨김을 배선이 저장·복원한다(예: 사용자·화주별 서버 저장).
   *  키 = 표 노드 id(재핸드오프로 표가 늘어도 밀리지 않는다). 함수 — 매 렌더 같은 자리에서 불리므로 안에서 저장 훅을 써도 된다.
   *  인자 columns = 그 표에 넘기는 컬럼 정의(정의 순서·기본 fixed) — 콜백은 바뀐 컬럼만 주므로 전체 상태 저장·고정 해제 복원에 쓴다.
   *  표에 따라 렌더마다 새 배열이다(본문 상수) — effect·memo 의존성에는 배열 대신 내용(dataIndex·fixed 목록)을 쓴다.
   *  없거나 그 표 키가 없으면 종전대로 표 내부 상태(저장 안 함). */
  columnLayout?: { "inqAllTable"?: (columns: core.CoreColumnType[]) => ColumnLayout }
  /** 버튼 권한(LOGISPRD-16733) — 메뉴 API 의 버튼 권한 계산 결과. 없으면 전부 보이고 편집된다(지금 동작).
   *  canShow = code 가 붙은 버튼 노출 · toolbar = 엑셀 업로드·다운로드 등 툴바 버튼 · editable = false 면 [일괄 입력]을 숨긴다 ·
   *  columns = 표 컬럼(잠금이면 편집 셀을 글자로 바꿔 돌려준다 — 채우기·Delete·타이핑도 함께 막힌다). */
  permission?: { canShow: (code: ButtonCode) => boolean; toolbar: ToolbarConfig; editable: boolean; columns: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
}

// ⚠ 그룹 cmp.TitleRow #inqAllTitle 인스턴스 prop 무시: align, justify, titleSticky — 정의(마커·propsSchema)에 없어 데모도 그리지 않는다(옛 노드 시절 잔재). 정리는 컨덕터 저장본에서.
const INQALLSHIPPER_TYPE_OPTIONS_DEMO: Option[] = [{"label":"M1P","value":"M1P"},{"label":"MFS","value":"MFS"},{"label":"MWP","value":"MWP"},{"label":"MLT","value":"MLT"},{"label":"MCD","value":"MCD"},{"label":"MTP","value":"MTP"}]
const INQALLSHIPPER_NAME_OPTIONS_DEMO: Option[] = [{"label":"무신사스탠다드","value":"무신사스탠다드"},{"label":"무신사","value":"무신사"},{"label":"29CM","value":"29CM"},{"label":"글로벌세일즈","value":"글로벌세일즈"}]
const INQALLORDTYPE_OPTIONS_DEMO: Option[] = [{"label":"해외","value":"해외"},{"label":"폐기","value":"폐기"},{"label":"테스트","value":"테스트"},{"label":"증정","value":"증정"},{"label":"재고이동","value":"재고이동"},{"label":"일반","value":"일반"},{"label":"사내(해외)","value":"사내(해외)"},{"label":"사내","value":"사내"},{"label":"반품","value":"반품"},{"label":"명품","value":"명품"},{"label":"교환","value":"교환"},{"label":"PLUS","value":"PLUS"}]
const INQALLORDSTATUS_OPTIONS_DEMO: Option[] = [{"label":"출고완료","value":"출고완료"},{"label":"입고취소","value":"입고취소"},{"label":"입고완료","value":"입고완료"},{"label":"입고대기","value":"입고대기"},{"label":"미출고","value":"미출고"},{"label":"가송장","value":"가송장"}]
// 조회 조건 기본값(데모) — 옵션을 API 로 바꾸면(예: 화주 = 코드) wiring.filterDefaults.inqAllFilterCard 가 같은 키를 그 value 로 덮어쓴다(예: 로그인 사용자 화주 코드).
const flInqAllFilterCardDefaults_DEMO: Record<string, unknown> = {}
// ⚠ 그룹 cmp.FilterCard #inqAllFilterCard 인스턴스 prop 무시: bodyPadding, filterFrame — 정의(마커·propsSchema)에 없어 데모도 그리지 않는다(옛 노드 시절 잔재). 정리는 컨덕터 저장본에서.
const COLUMNS: core.CoreColumnType[] = [{"title":"화주타입","width":100,"dataIndex":"service_type"},{"title":"화주코드","width":120,"dataIndex":"SPR_NM"},{"title":"화주명","width":180,"dataIndex":"shipper_name"},{"title":"입고유형","width":100,"dataIndex":"ORD_TYPE"},{"title":"브랜드","width":180,"dataIndex":"BRD_NM"},{"title":"품목","width":120,"dataIndex":"GDS_GROUP1"},{"title":"상품번호","width":160,"dataIndex":"GDS_CD"},{"title":"상품명","width":240,"dataIndex":"GDS_NM"},{"title":"스타일넘버","width":160,"dataIndex":"STL_NO"},{"title":"옵션","width":120,"dataIndex":"GDS_OPT"},{"align":"right","title":"수량","width":120,"dataIndex":"ORD_QTY"},{"title":"바코드","width":180,"dataIndex":"BARCODE"},{"title":"주문번호","width":160,"dataIndex":"ORD_NO"},{"title":"입고번호","width":160,"dataIndex":"ORD_OPT_NO"},{"title":"입고상태","width":120,"variant":"tag","dataIndex":"ORD_STATUS","variantProps":{"tagColors":{"가송장":"warning","미출고":"default","입고대기":"processing","입고완료":"success","입고취소":"error","출고완료":"processing"}}},{"title":"입고예정일자","width":120,"dataIndex":"PLN_DATE"},{"title":"입고일자","width":120,"dataIndex":"ACT_DATE"},{"align":"right","title":"입고실적수량","width":120,"dataIndex":"ACT_QTY"},{"title":"단위코드","width":100,"dataIndex":"ULD_TYPE"},{"title":"배송유형","width":120,"dataIndex":"TRS_TYPE"},{"title":"배송유형상세","width":120,"dataIndex":"TRS_TYPE_DETAIL"},{"title":"배송업체명","width":180,"dataIndex":"TRS_LSP_NM"},{"title":"운전자명","width":120,"dataIndex":"DRV_NAME"},{"title":"차량번호","width":120,"dataIndex":"TRS_NUMBER"},{"title":"배송출발일자","width":120,"dataIndex":"TRS_DEPT_DT"},{"title":"배송도착일자","width":120,"dataIndex":"TRS_ARRV_DT"},{"title":"참조번호","width":120,"dataIndex":"REF_NO"},{"title":"참조상세번호","width":120,"dataIndex":"REF_OPT_NO"},{"title":"주문특이사항","width":350,"dataIndex":"ORD_PROC_NM"},{"title":"상품특이사항","width":350,"dataIndex":"PROC_NM"},{"title":"생성일시","width":180,"dataIndex":"INS_DATE"},{"title":"생성자","width":120,"dataIndex":"INS_BY"},{"title":"수정일시","width":180,"dataIndex":"UPD_DATE"},{"title":"수정자","width":120,"dataIndex":"UPD_BY"},{"title":"거래유형","width":120,"dataIndex":"LOT_ATTR5"},{"title":"최신입고완료일자","width":140,"dataIndex":"ACT_DATE"}]
// TODO(api): ROWS 는 데모 목데이터 6행 중 앞 5행 — 실제 데이터로 교체(전체 표본은 패키지 data-requirements.json)
const ROWS_DEMO: Record<string, unknown>[] = [{"BRD_NM":"무신사스탠다드","GDS_CD":"GDS-2024-0001","GDS_NM":"릴렉스드 코튼 티셔츠","INS_BY":"이나연","ORD_NO":"ORD20260703001","REF_NO":"REF-0001","SPR_NM":"MSS","STL_NO":"MSS-24-TS-001","UPD_BY":"이나연","ACT_QTY":300,"BARCODE":"8809123400011","GDS_OPT":"블랙 M","ORD_QTY":300,"PROC_NM":"","ACT_DATE":"2026-07-04","DRV_NAME":"김운송","INS_DATE":"2026-07-03 10:12","ORD_TYPE":"일반","PLN_DATE":"2026-07-04","TRS_TYPE":"차량","ULD_TYPE":"EA","UPD_DATE":"2026-07-04 09:20","LOT_ATTR5":"온라인","GDS_GROUP1":"의류","ORD_OPT_NO":"IN20260703001","ORD_STATUS":"입고완료","REF_OPT_NO":"REF-0001-01","TRS_LSP_NM":"무신사로지스틱스","TRS_NUMBER":"경기12가3456","ORD_PROC_NM":"","TRS_ARRV_DT":"2026-07-04","TRS_DEPT_DT":"2026-07-04","service_type":"MFS","shipper_name":"무신사스탠다드","TRS_TYPE_DETAIL":"전세차량"},{"BRD_NM":"무신사스탠다드","GDS_CD":"GDS-2024-0002","GDS_NM":"릴렉스드 코튼 티셔츠","INS_BY":"이나연","ORD_NO":"ORD20260703001","REF_NO":"REF-0001","SPR_NM":"MSS","STL_NO":"MSS-24-TS-001","UPD_BY":"이나연","ACT_QTY":0,"BARCODE":"8809123400028","GDS_OPT":"화이트 L","ORD_QTY":250,"PROC_NM":"오배송 주의 — 옵션 라벨 확인","ACT_DATE":"","DRV_NAME":"김운송","INS_DATE":"2026-07-03 10:12","ORD_TYPE":"일반","PLN_DATE":"2026-07-04","TRS_TYPE":"차량","ULD_TYPE":"EA","UPD_DATE":"2026-07-03 10:12","LOT_ATTR5":"온라인","GDS_GROUP1":"의류","ORD_OPT_NO":"IN20260703001","ORD_STATUS":"입고대기","REF_OPT_NO":"REF-0001-02","TRS_LSP_NM":"무신사로지스틱스","TRS_NUMBER":"경기12가3456","ORD_PROC_NM":"","TRS_ARRV_DT":"","TRS_DEPT_DT":"2026-07-04","service_type":"MFS","shipper_name":"무신사스탠다드","TRS_TYPE_DETAIL":"전세차량"},{"BRD_NM":"29CM","GDS_CD":"GDS-2024-1101","GDS_NM":"와이드 데님 팬츠","INS_BY":"김재고","ORD_NO":"ORD20260703014","REF_NO":"REF-0042","SPR_NM":"29CM","STL_NO":"29-DN-2201","UPD_BY":"김재고","ACT_QTY":118,"BARCODE":"8809555100034","GDS_OPT":"인디고 30","ORD_QTY":120,"PROC_NM":"","ACT_DATE":"2026-07-05","DRV_NAME":"","INS_DATE":"2026-07-03 10:12","ORD_TYPE":"재고이동","PLN_DATE":"2026-07-05","TRS_TYPE":"택배","ULD_TYPE":"BOX","UPD_DATE":"2026-07-05 15:02","LOT_ATTR5":"온라인","GDS_GROUP1":"의류","ORD_OPT_NO":"IN20260703014","ORD_STATUS":"입고완료","REF_OPT_NO":"REF-0042-01","TRS_LSP_NM":"CJ대한통운","TRS_NUMBER":"","ORD_PROC_NM":"분할 입고(2건 중 1건)","TRS_ARRV_DT":"2026-07-05","TRS_DEPT_DT":"2026-07-04","service_type":"M1P","shipper_name":"29CM","TRS_TYPE_DETAIL":"일반택배"},{"BRD_NM":"글로벌세일즈","GDS_CD":"GDS-2024-2031","GDS_NM":"램스울 크루넥 니트","INS_BY":"박입고","ORD_NO":"ORD20260703022","REF_NO":"REF-0107","SPR_NM":"GS","STL_NO":"GS-KN-0031","UPD_BY":"박입고","ACT_QTY":0,"BARCODE":"8809777200057","GDS_OPT":"오트밀 M","ORD_QTY":60,"PROC_NM":"","ACT_DATE":"","DRV_NAME":"박기사","INS_DATE":"2026-07-03 10:12","ORD_TYPE":"반품","PLN_DATE":"2026-07-05","TRS_TYPE":"차량","ULD_TYPE":"EA","UPD_DATE":"2026-07-04 09:20","LOT_ATTR5":"오프라인","GDS_GROUP1":"잡화","ORD_OPT_NO":"IN20260703022","ORD_STATUS":"입고취소","REF_OPT_NO":"REF-0107-01","TRS_LSP_NM":"한진","TRS_NUMBER":"서울88바1122","ORD_PROC_NM":"화주 요청 취소","TRS_ARRV_DT":"","TRS_DEPT_DT":"","service_type":"MWP","shipper_name":"글로벌세일즈","TRS_TYPE_DETAIL":"용차"},{"BRD_NM":"글로벌세일즈","GDS_CD":"GDS-2024-2032","GDS_NM":"램스울 브이넥 니트","INS_BY":"박입고","ORD_NO":"ORD20260703022","REF_NO":"REF-0108","SPR_NM":"GS","STL_NO":"GS-KN-0032","UPD_BY":"박입고","ACT_QTY":0,"BARCODE":"8809777200064","GDS_OPT":"네이비 L","ORD_QTY":90,"PROC_NM":"","ACT_DATE":"","DRV_NAME":"","INS_DATE":"2026-07-03 10:12","ORD_TYPE":"일반","PLN_DATE":"2026-07-06","TRS_TYPE":"택배","ULD_TYPE":"EA","UPD_DATE":"2026-07-03 10:12","LOT_ATTR5":"오프라인","GDS_GROUP1":"잡화","ORD_OPT_NO":"IN20260703023","ORD_STATUS":"가송장","REF_OPT_NO":"REF-0108-01","TRS_LSP_NM":"롯데글로벌로지스","TRS_NUMBER":"","ORD_PROC_NM":"","TRS_ARRV_DT":"","TRS_DEPT_DT":"","service_type":"MWP","shipper_name":"글로벌세일즈","TRS_TYPE_DETAIL":"일반택배"}]
// TODO(dev): ROWS 행 key — wiring.rows 가 행에 key(BE 행 id)를 실으면 그것이 쓰인다(스프레드가 인덱스를 덮는다). 안 실으면 배열 인덱스라 재조회·페이지 이동 뒤 체크 선택이 다른 행에 붙는다. 행 고유 필드(BE 행 id)를 rowKey 로(컨덕터 표 속성 rowKey 지정 시 자동) — 또는 wiring.rows 가 행에 key 를 실으면 스프레드가 인덱스를 덮어 그 값이 쓰인다.
const REASONRADIO_OPTIONS_DEMO: Option[] = [{"label":"업무활용","value":"업무활용"},{"label":"고객요청","value":"고객요청"},{"label":"데이터 검증","value":"데이터 검증"},{"label":"기타","value":"기타"}]
// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
const selCtx = (): ActionCtx => ({ selected: selRef.current })

const POPUP_DOWN = {
  bottomLeft: { points: ['tl', 'bl'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
  bottomRight: { points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
}

const chipCodes = (v: unknown): string | null => (Array.isArray(v) && v.length ? `${(v as string[])[0]}${v.length > 1 ? ` 외 ${v.length - 1}개` : ''}` : null)

const chipSelect = (opts: Option[], v: unknown, required?: boolean): string | null =>
  v == null || v === '' ? (required ? '전체' : null) : (opts.find((o) => o.value === v)?.label ?? String(v as string | number))

const chipMulti = (opts: Option[], v: unknown, required?: boolean): string | null => {
  const arr = (Array.isArray(v) ? (v as string[]) : []).filter((x) => x !== '')
  return arr.length ? `${opts.find((o) => o.value === arr[0])?.label ?? arr[0]}${arr.length > 1 ? ` 외 ${arr.length - 1}` : ''}` : required ? '전체' : null
}

const chipRange = (v: unknown, fmt = 'YY-MM-DD'): string | null => (Array.isArray(v) && v[0] && v[1] ? `${dayjs(String(v[0])).format(fmt)} ~ ${dayjs(String(v[1])).format(fmt)}` : null)

const chipDate = (v: unknown): string | null => (typeof v === 'string' && v ? dayjs(v).format('YY-MM-DD') : null)

/** 기본 기간 프리셋 → ['YYYY-MM-DD','YYYY-MM-DD']. periodBase 'futureTo' = 오늘~+N(입고예정일 등) / 'pastTo' = -N~오늘. */
const presetRange = (preset?: string, periodBase: 'futureTo' | 'pastTo' = 'futureTo'): [string, string] | undefined => {
  if (!preset) return undefined
  const now = dayjs()
  const n = preset === 'today' ? [0, 'day'] : preset === 'week' ? [6, 'day'] : preset === 'month' ? [1, 'month'] : null
  if (!n) return undefined
  const other = periodBase === 'futureTo' ? now.add(n[0] as number, n[1] as 'day' | 'month') : now.subtract(n[0] as number, n[1] as 'day' | 'month')
  const [a, b] = periodBase === 'futureTo' ? [now, other] : [other, now]
  return [a.format('YYYY-MM-DD'), b.format('YYYY-MM-DD')]
}

const toDayjsPair = (v: unknown): [Dayjs, Dayjs] | null => (Array.isArray(v) && v[0] && v[1] ? [dayjs(String(v[0])), dayjs(String(v[1]))] : null)

/** 조회영역 필드 프레임(그룹 cmp.FilterField) — 접힘이면 값 칩(값 없으면 숨김), 열림이면 DS FormItem(라벨 위). 규격 = pbo-core filter-layout.css .pbo-filter-field */
function FilterField({ collapsed, label, required, tooltip, width, chip, children }: { collapsed: boolean; label?: string; required?: boolean; tooltip?: string; width?: number | string; chip?: string | null; children?: ReactNode }) {
  if (collapsed) {
    return (
      <div className="pbo-filter-closed" hidden={chip == null}>
        {label ? (
          <div className="pbo-filter-chip-label">
            <label>{label}</label>
            {required ? <span className="pbo-filter-req">*</span> : null}
          </div>
        ) : null}
        <div className="pbo-filter-chip-value">{chip}</div>
      </div>
    )
  }
  return (
    <core.FormItem className="pbo-filter-field" label={label} required={required} tooltip={!!tooltip} tooltipText={tooltip} labelPosition="top" boxedItem={false} style={width != null ? { width } : undefined}>
      {children}
    </core.FormItem>
  )
}

/** 다건 코드 입력 — 인풋 + 우측 [+] 팝오버 textarea(Enter 로 다중 입력, 최대 `limit` — 기본 1,500). 규격 = .pbo-filter-code*
 *  구분자는 인풋·팝오버 모두 쉼표·공백·줄바꿈(1.0 코드 입력 동치 — 같은 문자열이 두 경로에서 다르게 해석되지 않게).
 *  한도는 자르지 않는다 — 초과분을 그대로 내보내 화면의 한도 경고가 살아 있게 한다(잘라 내면 앞 N개만 조용히 조회된다, moms-fe #739 Critical 2026-09-11). */
function MultiCodeInput({ value, onChange, placeholder, limit = 1500 }: { value: string[]; onChange: (v: string[]) => void; placeholder?: string; limit?: number }) {
  const [open, setOpen] = useState(false)
  // 편집 원문 두 벌(인풋=쉼표·팝오버=줄) — 밖으로 내는 배열만 정규화한다. 입력마다 정규화해 되돌려 쓰면 끝의 구분자가 즉시 지워진다.
  const [text, setText] = useState(value.join('\n'))
  const [line, setLine] = useState(value.join(', '))
  const wrapRef = useRef<HTMLDivElement>(null)
  const joined = value.join('\n')
  const normalize = (raw: string, splitBy: RegExp) => Array.from(new Set(raw.split(splitBy).map((s) => s.trim()).filter(Boolean)))
  const shown = normalize(text, /[\s,]+/)
  // 밖에서 값이 바뀌었을 때만(초기화·복원) 원문을 따라간다 — 내 입력이 만든 값이면 원문(끝의 구분자 포함)을 보존한다.
  const lastEmit = useRef(joined)
  useEffect(() => {
    if (joined === lastEmit.current) return
    lastEmit.current = joined
    setText(joined)
    setLine(value.join(', '))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joined])
  const emit = (arr: string[]) => {
    lastEmit.current = arr.join('\n')
    onChange(arr)
  }
  const onLine = (raw: string) => {
    setLine(raw)
    const arr = normalize(raw, /[\s,]+/)
    setText(arr.join('\n'))
    emit(arr)
  }
  const onText = (raw: string) => {
    setText(raw)
    const arr = normalize(raw, /[\s,]+/)
    setLine(arr.join(', '))
    emit(arr)
  }
  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false)
    }
    window.addEventListener('mousedown', onDown)
    return () => window.removeEventListener('mousedown', onDown)
  }, [open])
  return (
    <div className="pbo-filter-code" ref={wrapRef} style={{ position: 'relative', width: '100%' }}>
      <core.Input
        placeholder={placeholder ?? '다건 입력 시, 우측 + 버튼을 눌러주세요.'}
        value={line}
        onChange={(e) => onLine(e.target.value)}
        suffix={<PlusOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14, cursor: 'pointer' }} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.stopPropagation(); setOpen(true) }} />}
      />
      {open && (
        <div className="pbo-filter-code-pop">
          <core.Input.TextArea
            value={text}
            placeholder="입력 후 Enter 키로 다중 입력이 가능합니다."
            onChange={(e) => onText(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && shown.length >= limit) e.preventDefault() }}
            autoSize={{ minRows: 4, maxRows: 16 }}
            autoFocus
          />
          <div className="pbo-filter-code-foot">
            <span style={{ fontSize: 12, color: shown.length > limit ? '#ff4d4f' : '#8c8c8c' }}>{shown.length} / {limit.toLocaleString()}</span>
            <core.Button size="small" onClick={() => onText('')}>
              초기화
            </core.Button>
          </div>
        </div>
      )}
    </div>
  )
}

/** 글자 폭 측정 — canvas 는 모듈에 한 번만(렌더마다 createElement 금지, no-return-assign 도 피한다). */
let measureCtx: CanvasRenderingContext2D | null | undefined
function measureTextWidth(t: string, font: string): number {
  if (measureCtx === undefined) measureCtx = document.createElement('canvas').getContext('2d')
  if (!measureCtx) return t.length * 8
  measureCtx.font = font
  return measureCtx.measureText(t).width
}
/** 멀티 셀렉트 — 상단 검색창 + 체크 + 화살표 플립 + 하단 [초기화]. allOption 이면 '' = '전체'(다른 값과 배타). 규격 = .pbo-filter-select* */
function MultiSelectBox({ value, onChange, options, placeholder, allOption = false, allDisabled = false, className, disabled = false }: { value: string[]; onChange: (v: string[]) => void; options: Option[]; placeholder?: string; allOption?: boolean; allDisabled?: boolean; className?: string; disabled?: boolean }) {
  const [searchQ, setSearchQ] = useState('')
  const [ddOpen, setDdOpen] = useState(false)
  const keep = useRef(false)
  // 보이는 태그 수 = 칸 폭과 글자 폭으로 **직접 계산**(사용자 확정 2026-09-09 "첫 값은 나오고 +n, 넓으면 2개, 안 깨지게").
  //  antd responsive 는 첫 태그조차 안 들어가면 0개로 접고, 값이 바뀔 때마다 재측정하며 깜빡였다(실측). 최소 1개, 나머지는 '+n'.
  const hostRef = useRef<HTMLDivElement>(null)
  const [hostW, setHostW] = useState(0)
  useLayoutEffect(() => {
    const el = hostRef.current
    if (!el) return
    setHostW(el.clientWidth)
    const ro = new ResizeObserver(() => setHostW(el.clientWidth))
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  const maxTagCount = (() => {
    if (!hostW || value.length <= 1) return value.length || 1
    const font = hostRef.current ? getComputedStyle(hostRef.current).font || '14px sans-serif' : '14px sans-serif'
    const tw = (t: string) => measureTextWidth(t, font)
    const labelOf = (v: string) => (v === '' ? '전체' : (options.find((o) => o.value === v)?.label ?? v))
    const avail = hostW - 8 - 18 - 4 // 좌우 패딩·화살표·검색 칸
    const MIN_TAG = 56 // 태그가 말줄임으로 줄어들 수 있는 하한(≈3글자 + ×) — 이만큼이라도 들어가면 하나 더 보인다("2개 나오고 말줄임")
    let used = 0
    let n = 0
    for (let i = 0; i < value.length; i++) {
      const w = tw(labelOf(value[i])) + 8 + 16 + 2 // 태그 패딩·닫기 아이콘·간격
      const rest = i + 1 < value.length ? tw(`+${value.length - i - 1}`) + 10 : 0
      if (n > 0 && used + Math.min(w, MIN_TAG) + rest > avail) break
      used += Math.min(w, Math.max(MIN_TAG, avail - used - rest))
      n++
    }
    return Math.max(1, n)
  })()
  const optionsData = [...(allOption ? [{ value: '', label: '전체', disabled: allDisabled }] : []), ...options]
  const emit = (next: string[]) => {
    if (!allOption) return onChange(next)
    if (next.includes('') && !value.includes('')) return onChange([''])
    if (next.length > 1 && next.includes('')) return onChange(next.filter((v) => v !== ''))
    onChange(next)
  }
  return (
    <div ref={hostRef} className={['pbo-filter-select-host', className].filter(Boolean).join(' ')} style={{ width: '100%', minWidth: 0 }}>
    <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN}
      className={['pbo-filter-select', 'pbo-filter-select-multi', value.length > 1 ? 'pbo-filter-select-many' : ''].filter(Boolean).join(' ')}
      mode="multiple"
      value={value}
      onChange={emit}
      showSearch
      allowClear
      placeholder={placeholder}
      options={optionsData}
      optionFilterProp="label"
      style={{ width: '100%' }}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={(omitted) => (omitted.length ? `+${omitted.length}` : null)}
      searchValue={searchQ}
      onSearch={setSearchQ}
      disabled={disabled}
      open={ddOpen}
      onFocus={() => setDdOpen(true)}
      onClick={() => setDdOpen(true)}
      onBlur={() => {
        if (keep.current) return
        setDdOpen(false)
        setSearchQ('')
      }}
      suffixIcon={ddOpen ? <UpOutlined style={{ pointerEvents: 'none', color: 'rgba(0, 0, 0, 0.45)' }} /> : <DownOutlined style={{ pointerEvents: 'none', color: 'rgba(0, 0, 0, 0.45)' }} />}
      // eslint-disable-next-line react/no-unstable-nested-components -- antd dropdownRender 는 렌더 prop(컴포넌트 정의 아님)
      dropdownRender={(menu) => (
        <>
          <div style={{ padding: '4px 8px', borderBottom: '1px solid rgba(5, 5, 5, 0.06)' }}>
            <core.Input
              size="small"
              variant="borderless"
              placeholder="검색어 입력"
              prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,0.25)' }} />}
              suffix={searchQ ? <CloseCircleFilled style={{ color: 'rgba(0,0,0,0.25)', cursor: 'pointer' }} onMouseDown={(e) => { e.preventDefault(); setSearchQ('') }} /> : <span />}
              value={searchQ}
              onChange={(e) => setSearchQ(e.target.value)}
              onMouseDown={() => { keep.current = true }}
              onFocus={() => { keep.current = true }}
              onBlur={() => {
                keep.current = false
                setDdOpen(false)
                setSearchQ('')
              }}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
          {menu}
          <div className="pbo-filter-reset-footer" onMouseDown={(e) => e.preventDefault()}>
            <core.Button size="small" onClick={() => onChange(allOption ? [''] : [])}>
              초기화
            </core.Button>
          </div>
        </>
      )}
    />
    </div>
  )
}

/** 기간 필드 — [기간유형 셀렉트 120 고정] + 레인지피커(프리셋 태그·'오늘/최근 N개월' 푸터·maxRangeDays·periodBase·좁으면 MM-DD). 값 = ['YYYY-MM-DD','YYYY-MM-DD']. */
function DateRangeField({ value, onChange, defaultPeriod, periodBase = 'futureTo', maxRangeDays, hidePresets, typeOptions, format = 'YY-MM-DD' }: { value?: [string, string]; onChange: (v: [string, string] | undefined) => void; defaultPeriod?: string; periodBase?: 'futureTo' | 'pastTo'; maxRangeDays?: number; hidePresets?: boolean; typeOptions?: Option[]; format?: string }) {
  const TAG: Record<string, string> = { today: '오늘', week: '일주일', month: '1개월' }
  const def = presetRange(defaultPeriod, periodBase)
  // 값이 비면(진입·초기화) 기본 기간으로 되돌려 보고한다 — 조회 조건에도 기본 기간이 걸린다.
  useEffect(() => {
    if (!value && def) onChange(def)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  // 프리셋 태그는 **현재 값**에서 유도한다 — 조회영역을 접었다 펴면 이 컴포넌트가 리마운트되는데, 기본 프리셋으로 초기화하면
  //  실제 기간이 달라도 태그가 '오늘' 로 돌아간다(moms-fe #738 리뷰 2026-09-11). 값이 프리셋과 일치할 때만 태그를 단다.
  const tagOf = (v?: [string, string]): string | null => {
    if (!v) return (defaultPeriod && TAG[defaultPeriod]) ?? null
    const hit = Object.keys(TAG).find((k) => { const r = presetRange(k, periodBase); return !!r && r[0] === v[0] && r[1] === v[1] })
    return hit ? TAG[hit] : null
  }
  const [tag, setTag] = useState<string | null>(() => tagOf(value))
  const [selected, setSelected] = useState(0)
  const [open, setOpen] = useState(false)
  const [epoch, setEpoch] = useState(0)
  const [panel, setPanel] = useState<'date' | 'month' | 'year'>('date')
  const rootRef = useRef<HTMLDivElement>(null)
  const [compact, setCompact] = useState(false)
  useEffect(() => {
    const el = rootRef.current
    if (!el || !typeOptions?.length) return
    const ro = new ResizeObserver(() => setCompact(el.clientWidth > 0 && el.clientWidth < 260))
    ro.observe(el)
    return () => ro.disconnect()
  }, [typeOptions])
  const apply = (next: [Dayjs, Dayjs], label: string, months: number) => {
    onChange([next[0].format('YYYY-MM-DD'), next[1].format('YYYY-MM-DD')])
    setSelected(months)
    setTag(label)
    setOpen(false)
    setEpoch((e) => e + 1)
  }
  const picker = (
    <core.DatePicker.RangePicker placement="bottomLeft" {...({ builtinPlacements: POPUP_DOWN } as object)}
      key={`${epoch}-${compact ? 'c' : 'f'}`}
      className={typeOptions?.length ? 'pbo-filter-picker' : 'pbo-filter-picker pbo-filter-picker-full'}
      allowClear={false}
      format={compact ? 'MM-DD' : format}
      placeholder={['시작일', '종료일']}
      value={toDayjsPair(value ?? def)}
      open={open}
      onOpenChange={setOpen}
      onPanelChange={(_v, modes) => setPanel(((modes as string[]).find((x) => x !== 'date') as 'month' | 'year' | undefined) ?? 'date')}
      prefix={tag ? <core.Tag className="pbo-filter-date-tag" color="default" style={{ marginInlineEnd: 4 }}>{tag}</core.Tag> : undefined}
      onChange={(vals) => {
        setSelected(0)
        setTag(vals && vals[0] && vals[1] ? '직접' : null)
        onChange(vals && vals[0] && vals[1] ? [vals[0].format('YYYY-MM-DD'), vals[1].format('YYYY-MM-DD')] : undefined)
      }}
      disabledDate={(current, info) => {
        if (periodBase === 'pastTo' && current.isAfter(dayjs(), 'day')) return true
        if (maxRangeDays && info?.from && Math.abs(current.diff(info.from, 'days')) > maxRangeDays - 1) return true
        return false
      }}
      renderExtraFooter={
        hidePresets
          ? undefined
          : () => (
              <div className={`pbo-filter-date-footer ${panel}`}>
                <core.Button type="link" onClick={() => apply([dayjs(), dayjs()], '오늘', 0)}>
                  오늘
                </core.Button>
                <div className="pbo-filter-date-presets">
                  <span>{periodBase === 'pastTo' ? '최근' : '오늘부터'}</span>
                  {[1, 2, 3, 6].map((m) => (
                    <core.Button key={m} className={m === selected ? 'selected' : undefined} onClick={() => apply(periodBase === 'pastTo' ? [dayjs().subtract(m, 'month'), dayjs()] : [dayjs(), dayjs().add(m, 'month')], `${m}개월`, m)}>
                      {m}개월
                    </core.Button>
                  ))}
                </div>
              </div>
            )
      }
      style={{ width: '100%' }}
    />
  )
  if (!typeOptions?.length) return picker
  return (
    <div className="pbo-filter-date pbo-filter-row" ref={rootRef}>
      <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-type" options={typeOptions} defaultValue={typeOptions[0]?.value} popupMatchSelectWidth={false} />
      {picker}
    </div>
  )
}

/** 표 카운트 — 같은 core.TableSelectionScope 안 표의 선택 개수를 '선택 N / 전체' 로 함께 그린다(데모 TableStatRender 와 같은 규약). 스코프 밖이면 전체만. */
function SelStat(props: ComponentProps<typeof core.TableStat>) {
  const n = core.useTableSelectionCount()
  return <core.TableStat {...props} selectedCount={n && n > 0 ? n : undefined} />
}

/** 선택 행 브리지(문서 50 슬롯 2차) — 같은 core.TableSelectionScope 안 표의 선택 행을 모듈 변수 selRef 로 흘려 보낸다. 액션 슬롯이 ctx.selected 로 받는다. */
function SelBridge() {
  const s = core.useTableSelection()
  useEffect(() => { selRef.current = s?.rows ?? []; return () => { selRef.current = [] } }, [s?.rows]) // 언마운트·스코프 이탈 때 비운다(모듈 변수라 다음 인스턴스로 새지 않게, #772 봇)
  return null
}

export default function InboundInquiryAllPageView(props: { wiring: Wiring }) {
  wiring = props.wiring // 모듈 홀더 갱신 — 렌더마다 같은 참조
  const hdrinqAllTitle_titleRowDef = usePageHeaderSticky()
  // 조회영역 값 버스(그룹 #inqAllFilterCard) — 각 필드가 filterKey(없으면 노드 id)를 키로 값을 올린다. [초기화]는 기본값으로 되돌리고 토큰을 올려
  //  모든 필드를 기본값으로 되돌린다(DS resetToken 계약). [조회]는 이 객체를 그대로 쿼리 조건으로 쓴다.
  const flInqAllFilterCardDefaults = useMemo(() => (wiring.filterDefaults?.inqAllFilterCard ?? ((d: Record<string, unknown>) => d))(flInqAllFilterCardDefaults_DEMO), []) // 조회 조건 기본값 — wiring.filterDefaults 슬롯(동기). [초기화] 가 돌아가는 값
  const flInqAllFilterCardDefaultsInitial = useMemo(() => (wiring.filterInitial?.inqAllFilterCard ?? ((d: Record<string, unknown>) => d))(flInqAllFilterCardDefaults), []) // 진입 초기값 — wiring.filterInitial 슬롯(동기, 예: URL 복원). 없으면 기본값
  const [flInqAllFilterCard, setFlInqAllFilterCard] = useState<Record<string, unknown>>(flInqAllFilterCardDefaultsInitial)
  const [flInqAllFilterCardReset, setFlInqAllFilterCardReset] = useState(0)
  // 조회영역 접기(그룹 #inqAllFilterCard) — 닫히면 필드가 값 칩으로 바뀌고 [필터 열기] 로 되돌린다(규격 CSS .pbo-filter-collapse-*).
  const [flInqAllFilterCardCollapsed, setFlInqAllFilterCardCollapsed] = useState(false)
  const INQALLSHIPPER_TYPE_OPTIONS = wiring.options?.INQALLSHIPPER_TYPE_OPTIONS ? wiring.options.INQALLSHIPPER_TYPE_OPTIONS(INQALLSHIPPER_TYPE_OPTIONS_DEMO) : INQALLSHIPPER_TYPE_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const INQALLSHIPPER_NAME_OPTIONS = wiring.options?.INQALLSHIPPER_NAME_OPTIONS ? wiring.options.INQALLSHIPPER_NAME_OPTIONS(INQALLSHIPPER_NAME_OPTIONS_DEMO) : INQALLSHIPPER_NAME_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const INQALLORDTYPE_OPTIONS = wiring.options?.INQALLORDTYPE_OPTIONS ? wiring.options.INQALLORDTYPE_OPTIONS(INQALLORDTYPE_OPTIONS_DEMO) : INQALLORDTYPE_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const INQALLORDSTATUS_OPTIONS = wiring.options?.INQALLORDSTATUS_OPTIONS ? wiring.options.INQALLORDSTATUS_OPTIONS(INQALLORDSTATUS_OPTIONS_DEMO) : INQALLORDSTATUS_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const [stSelEpoch, setStSelEpoch] = useState(0) // 토글 상태(스토어 키 'selEpoch')
  // 페이저 ↔ 표 짝(pagerKey 'pager') — 액션바 페이저가 페이지를 소유하고 표는 그 페이지만 그린다. '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24).
  const [pgPager, setPgPager] = useState(() => ({ page: wiring.stateInitial?.pager?.pager?.page ?? 1, size: wiring.stateInitial?.pager?.pager?.size ?? 10000 })) // 진입 초기값 = wiring.stateInitial(예: URL 복원)
  const [stListq_table_q, setStListq_table_q] = useState(wiring.stateInitial?.listq?.["table.q"] ?? '') // 토글 상태(스토어 키 'listq:table.q')
  const [stModal_inqAllDownloadModal, setStModal_inqAllDownloadModal] = useState(false) // 토글 상태(스토어 키 'modal:inqAllDownloadModal')
  const ROWS_R = wiring.rows.ROWS(ROWS_DEMO, { filters: flInqAllFilterCard, pager: pgPager }) // 표 데이터 — wiring.ts 슬롯(인자 = 데모 목데이터·조회 조건·페이저)
  const ROWS = Array.isArray(ROWS_R) ? ROWS_R : ROWS_R.rows
  const ROWS_CL = wiring.columnLayout?.inqAllTable?.(COLUMNS) // 컬럼 배치(순서·너비·고정·숨김) — 없으면 표 내부 상태
  const ROWS_TOTAL = Array.isArray(ROWS_R) ? ROWS.length : (ROWS_R.total ?? ROWS.length)
  // [목록 검색] 표시 컬럼 전체 부분일치(대소문자 무시) — 어댑터 TableRender listQ 규약. 확정은 검색칸 엔터/돋보기(onSearch).
  const ROWSListed = useMemo(() => {
    const q = stListq_table_q.trim().toLowerCase()
    if (!q) return ROWS
    const idx = COLUMNS.map((c) => c.dataIndex).filter((d): d is string => typeof d === 'string')
    const hit = (x: Record<string, unknown>) => idx.some((di) => String((x[di] ?? '') as string | number).toLowerCase().includes(q))
    return ROWS.flatMap((r) => {
      const kids = Array.isArray(r.children) ? (r.children as Record<string, unknown>[]) : undefined
      if (kids) { const kept = kids.filter(hit); if (kept.length) return [{ ...r, children: kept }]; return hit(r) ? [{ ...r, children: [] }] : [] }
      return hit(r) ? [r] : []
    })
  }, [stListq_table_q, ROWS])
  const ROWS_SERVERPAGED = !Array.isArray(ROWS_R) && ROWS_R.total != null // total 을 준 쪽이 서버 페이징
  const ROWS_PG = ROWS_SERVERPAGED ? pgPager.page : Math.min(pgPager.page, Math.max(1, Math.ceil(ROWSListed.length / pgPager.size))) // 건수가 줄어 지금 페이지가 범위를 넘으면 마지막 페이지를 그린다(옛 손코드 pageNo clamp — 목록 검색·업로드·삭제 뒤 빈 표 방지). 페이저 표시·onState 도 이 값(상태는 그대로 — 복원한 페이지를 로딩 중 0건으로 잃지 않는다)
  const ROWS_PAGE = ROWS_SERVERPAGED ? ROWSListed : ROWSListed.slice((ROWS_PG - 1) * pgPager.size, ROWS_PG * pgPager.size)
  const REASONRADIO_OPTIONS = wiring.options?.REASONRADIO_OPTIONS ? wiring.options.REASONRADIO_OPTIONS(REASONRADIO_OPTIONS_DEMO) : REASONRADIO_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const [fs_inqAllDownloadModal, setFs_inqAllDownloadModal] = useState<FormState>({}) // 폼 버스 'inqAllDownloadModal' — 입력이 발행한 값
  const fsx_inqAllDownloadModal: FormState = wiring.form?.inqAllDownloadModal ? wiring.form.inqAllDownloadModal(fs_inqAllDownloadModal) : fs_inqAllDownloadModal // 유효 상태(wiring.form 이 파생 필드를 덮어쓴다)
  const fset_inqAllDownloadModal = (field: string, v: unknown) => setFs_inqAllDownloadModal((s) => ({ ...s, [field]: v }))
  useEffect(() => { // 열 때 폼 버스의 openResetFields 를 비운다(입력 DOM 은 destroyOnClose 로 새로 마운트)
    if (stModal_inqAllDownloadModal) setFs_inqAllDownloadModal((s) => { const n = { ...s }; ["reason","detail"].forEach((f) => { delete n[f] }); return n })
  }, [stModal_inqAllDownloadModal])
  useEffect(() => { document.body.classList.add('pbo-screen-portal'); return () => { document.body.classList.remove('pbo-screen-portal') } }, [])
  useEffect(() => { wiring.onState?.({ pager: { "pager": { ...pgPager, page: ROWS_PG } }, listq: { "table.q": stListq_table_q } }) }, [pgPager, ROWS_PG, stListq_table_q]) // 화면 상태 → 배선(URL/세션 persist)
  return (
    <core.ConfigProvider theme={pboLogisticsTheme}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #inboundInquiryAll InboundInquiryAllPage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="입고조회(전체)" />
          {/* ▼ 그룹 cmp.TitleRow #inqAllTitle — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #inqAllTitle:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrinqAllTitle_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrinqAllTitle_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #inqAllTitle:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>입고조회(전체)</core.Typography.Title>
            {/* #inqAllTitle:titleRight TitleRight */}
            <core.Flex gap={16} align="center">{null}</core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #inqAllTitle 끝 */}
          {/* ▼ 그룹 cmp.FilterCard #inqAllFilterCard — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #inqAllFilterCard:filterCardDef FilterCard */}
          <core.Card styles={{ body: { padding: "12px 20px" } }} style={{ border: '1px solid #d9d9d9', borderRadius: 8, minWidth: 0 }}>
            {/* #inqAllFilterCard:filterBody FilterBody */}
            <div className={`${flInqAllFilterCardCollapsed ? 'pbo-filter-collapse-closed' : 'pbo-filter-collapse-open'}`}>
              {flInqAllFilterCardCollapsed && <span className="pbo-filter-empty-msg">필터가 적용된 항목이 없어요. 필터를 열어 원하는 조건으로 검색해 보세요.</span>}
              {/* #inqAllFilterCard:filterFields FilterFields */}
              <core.Flex gap={20} align="flex-start" wrap>
                {/* ▼ 그룹 cmp.FilterField #inqAllShipper — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllShipper:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="화주유형/화주명" required chip={chipMulti([...INQALLSHIPPER_TYPE_OPTIONS, ...INQALLSHIPPER_NAME_OPTIONS], [...((flInqAllFilterCard["inqAllShipper.types"] as string[] | undefined) ?? []), ...((flInqAllFilterCard["inqAllShipper.names"] as string[] | undefined) ?? [])], true)}>
                  {/* #inqAllShipper:control Control */}
                  <div className="pbo-filter-row" style={{ width: '100%' }}>
                    <MultiSelectBox className="pbo-filter-type" options={INQALLSHIPPER_TYPE_OPTIONS} allOption disabled={wiring.filterDisabled?.service_type} placeholder="화주유형" value={((flInqAllFilterCard["inqAllShipper.types"] as string[] | undefined) ?? [''])} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, "inqAllShipper.types": v }))} />
                    <MultiSelectBox className="pbo-filter-value" options={INQALLSHIPPER_NAME_OPTIONS} allOption allDisabled={((flInqAllFilterCard["inqAllShipper.types"] as string[] | undefined) ?? ['']).includes('')} disabled={wiring.filterDisabled?.shipper_name} placeholder="화주명" value={((flInqAllFilterCard["inqAllShipper.names"] as string[] | undefined) ?? [''])} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, "inqAllShipper.names": v }))} />
                  </div>
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllShipper 끝 */}
                {/* ▼ 그룹 cmp.FilterField #inqAllPlnDate — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllPlnDate:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="입고예정일자" required chip={chipRange(flInqAllFilterCard.inqAllPlnDate)}>
                  {/* #inqAllPlnDate:control Control */}
                  <DateRangeField key={flInqAllFilterCardReset} value={flInqAllFilterCard.inqAllPlnDate as [string, string] | undefined} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, inqAllPlnDate: v }))} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllPlnDate 끝 */}
                {/* ▼ 그룹 cmp.FilterField #inqAllActDate — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllActDate:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="입고일자" chip={chipDate(flInqAllFilterCard.ACT_DATE)}>
                  {/* #inqAllActDate:control Control */}
                  <core.DatePicker placement="bottomLeft" {...({ builtinPlacements: POPUP_DOWN } as object)} format="YY-MM-DD" placeholder="날짜 선택" allowClear value={flInqAllFilterCard.ACT_DATE ? dayjs(flInqAllFilterCard.ACT_DATE as string) : null} onChange={(d) => setFlInqAllFilterCard((s) => ({ ...s, ACT_DATE: d ? d.format('YYYY-MM-DD') : undefined }))} style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllActDate 끝 */}
                {/* ▼ 그룹 cmp.FilterField #inqAllOrdType — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllOrdType:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="입고유형" chip={chipSelect(INQALLORDTYPE_OPTIONS, flInqAllFilterCard.ORD_TYPE ?? '', false)}>
                  {/* #inqAllOrdType:control Control */}
                  <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={[{ value: '', label: '전체' }, ...INQALLORDTYPE_OPTIONS]} value={(flInqAllFilterCard.ORD_TYPE as string | undefined) ?? ''} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, ORD_TYPE: v }))} placeholder="전체" style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllOrdType 끝 */}
                {/* ▼ 그룹 cmp.FilterField #inqAllOrdStatus — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllOrdStatus:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="입고상태" chip={chipSelect(INQALLORDSTATUS_OPTIONS, flInqAllFilterCard.ORD_STATUS ?? '', false)}>
                  {/* #inqAllOrdStatus:control Control */}
                  <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={[{ value: '', label: '전체' }, ...INQALLORDSTATUS_OPTIONS]} value={(flInqAllFilterCard.ORD_STATUS as string | undefined) ?? ''} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, ORD_STATUS: v }))} placeholder="전체" style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllOrdStatus 끝 */}
                {/* ▼ 그룹 cmp.FilterField #inqAllOrdOptNo — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #inqAllOrdOptNo:filterFieldDef FilterField */}
                <FilterField collapsed={flInqAllFilterCardCollapsed} label="입고번호" chip={chipCodes(flInqAllFilterCard.ORD_OPT_NO)}>
                  {/* #inqAllOrdOptNo:control Control */}
                  <MultiCodeInput value={(flInqAllFilterCard.ORD_OPT_NO as string[] | undefined) ?? []} onChange={(v) => setFlInqAllFilterCard((s) => ({ ...s, ORD_OPT_NO: v.length ? v : undefined }))} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #inqAllOrdOptNo 끝 */}
              </core.Flex>
              {/* #inqAllFilterCard:filterFooter FilterFooter */}
              <core.Flex gap={8} justify="flex-end" align="center">
                {/* #inqAllFilterCard:filterToggleButton FilterToggleButton */}
                <core.Button icon={flInqAllFilterCardCollapsed ? <DownOutlined /> : <UpOutlined />} onClick={() => setFlInqAllFilterCardCollapsed((c) => !c)}>{`필터 ${flInqAllFilterCardCollapsed ? '열기' : '닫기'}`}</core.Button>
                {/* #inqAllFilterCard:filterFooterDivider FilterFooterDivider */}
                <span style={{ height: 18, margin: '0 0px', borderLeft: '1px solid #d9d9d9', display: 'block', flex: 'none' }} />
                {/* #inqAllFilterCard:resetButton ResetButton */}
                {permCan('CLEAR') && <core.Button onClick={() => { setFlInqAllFilterCard(flInqAllFilterCardDefaults); setFlInqAllFilterCardReset((t) => t + 1); setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStListq_table_q(''); wiring.onReset?.() }}>초기화</core.Button>}
                {/* #inqAllFilterCard:searchButton SearchButton */}
                {permCan('SEARCH') && <core.Button type="primary" onClick={() => { setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStListq_table_q(''); Promise.resolve(wiring.actions.search(flInqAllFilterCard)).catch(() => undefined) }}>조회</core.Button>}
              </core.Flex>
            </div>
          </core.Card>
          {/* ▲ 그룹 cmp.FilterCard #inqAllFilterCard 끝 */}
          {/* ▼ 그룹 cmp.TableGroup #tableGroup — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #tableGroup:tableGroupDef TableGroup */}
          <core.TableSelectionScope key={stSelEpoch}><SelBridge />
            {/* #tableGroup:tableGroupInner TableGroupInner */}
            <core.Flex vertical gap={8} align="stretch">
              {/* #tableGroup:tableHeader TableHeader */}
              <core.Flex style={{ padding: "4px 0px 4px 0px" }} gap={8} justify="space-between" align="center" className="pbo-v2-actionbar-sticky">
                {/* #tableGroup:toolbarLeft ToolbarLeft */}
                <core.Space>
                  {/* #inqAllTableStat TableStat */}
                  <SelStat total={ROWS_TOTAL} />
                </core.Space>
                {/* #tableGroup:toolbarRight ToolbarRight */}
                <core.Space>
                  {/* #tableGroup:tablePager TablePager */}
                  <core.TablePager variant="paged" page={ROWS_PG} pageSize={pgPager.size} total={(stListq_table_q.trim() ? ROWSListed.length : ROWS_TOTAL)} showSizeChanger={false} onPage={(page, size) => { setStSelEpoch((n) => n + 1); setStListq_table_q(''); setPgPager({ page: size !== pgPager.size ? 1 : page, size }) }} />
                  {/* #tableGroup:listSearch ListSearch */}
                  <core.Input.Search placeholder="목록 검색" allowClear key={stSelEpoch} style={{ width: 240 }} defaultValue={stListq_table_q} onSearch={(v) => setStListq_table_q((v ?? '').trim())} />
                  {/* #tableGroup:toolbarDivider2 Divider */}
                  <span style={{ height: 18, margin: '0 4px', borderLeft: '1px solid #d9d9d9', display: 'block', flex: 'none' }} />
                  {/* #inqAllExcelButton ExcelButton */}
                  {permTool('download') && <core.Button icon={<DsIcon name="ic-download" size={16} color="currentColor" />} onClick={() => { if (wiring.opens?.inqAllExcelButton?.({ selected: [] }) === false) return; setStModal_inqAllDownloadModal(true) }}>엑셀 다운로드</core.Button>}
                </core.Space>
              </core.Flex>
              {/* #inqAllTable InqAllTable */}
              <core.Table columns={permCols(COLUMNS)} dataSource={ROWS_PAGE.map((r, i) => ({ key: i, ...r }))} loading={Array.isArray(ROWS_R) ? undefined : ROWS_R.loading} stickyOffset={104} size="middle" scroll={{ x: 'max-content' }} columnOrder={ROWS_CL?.columnOrder} onColumnOrderChange={ROWS_CL?.onColumnOrderChange} columnWidths={ROWS_CL?.columnWidths} onColumnWidthsChange={ROWS_CL?.onColumnWidthsChange} pinnedColumns={ROWS_CL?.pinnedColumns} onPinnedColumnsChange={ROWS_CL?.onPinnedColumnsChange} hiddenColumns={ROWS_CL?.hiddenColumns} onHiddenColumnsChange={ROWS_CL?.onHiddenColumnsChange} />
            </core.Flex>
          </core.TableSelectionScope>
          {/* ▲ 그룹 cmp.TableGroup #tableGroup 끝 */}
          {/* #inqAllDownloadModal DownloadModal */}
          <core.Modal destroyOnClose /* openResetFields: reason, detail — 닫힐 때 버려 열 때 새 폼 */ open={stModal_inqAllDownloadModal} onCancel={() => setStModal_inqAllDownloadModal(false)} onOk={() => { Promise.resolve(wiring.actions.inqAllDownloadModal_ok({ ...selCtx(), form: fsx_inqAllDownloadModal })).then((r) => { if (typeof r === 'string') core.message.success(r); setStSelEpoch((n) => n + 1);  setStModal_inqAllDownloadModal(false) }, () => undefined) /* 실패 = 슬롯이 토스트·throw — 모달을 열어 둔다. onOk 타입은 () => void 라 async 를 직접 주지 않는다(#772 봇) */ }} title="다운로드 사유" width={520} okText="확인" cancelText="취소">
            {/* #inqAllDownloadModal-form ReasonForm */}
            <core.Form layout="horizontal">
              {/* #inqAllDownloadModal-reason 사유코드Item */}
              <core.FormItem label="사유코드" required labelWidth={88}>
                {/* #inqAllDownloadModal-reasonRadio ReasonRadio */}
                <core.Radio.Group onChange={(e: { target: { value?: unknown } }) => fset_inqAllDownloadModal("reason", e.target.value)} options={REASONRADIO_OPTIONS} />
              </core.FormItem>
              {/* #inqAllDownloadModal-detail 상세사유Item */}
              <core.FormItem label="상세사유" required labelWidth={88}>
                {/* #inqAllDownloadModal-detailInput DetailInput */}
                <core.Input onChange={(e: { target: { value?: unknown } }) => fset_inqAllDownloadModal("detail", e.target.value)} placeholder="사유를 입력하세요" style={{ width: "100%" }} />
                {/* #inqAllDownloadModal-detailHelp Help */}
                <core.Typography.Text style={{ fontSize: 12 }} type="secondary">5글자 이상 입력해주세요.</core.Typography.Text>
              </core.FormItem>
            </core.Form>
          </core.Modal>
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
